import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import { twMerge } from "tailwind-merge";
import { formatDateTime } from "@utils/formatters";
import type { GeoJsonFeature } from "@typings/components/map";
import type { ReleaseGeoJsonProperties } from "@services/releases/getGeoJson/type";

const STATUS: Record<string, { style: string; label: string }> = {
  pending: { label: "Pendente", style: "bg-yellow-500" },
  canceled: { label: "Cancelada", style: "bg-red-600" },
  waiting_ok: { label: "Aguardando Análise do Admin", style: "bg-secondary" },
  concluded: { label: "Concluída", style: "bg-primary" },
  undefined: { label: "Desconhecido", style: "bg-gray-500" },
};

interface ReleasePopupProps {
  feature: GeoJsonFeature<ReleaseGeoJsonProperties>;
  onNavigate: (path: string) => void;
}
function ReleasePopup({ feature, onNavigate }: ReleasePopupProps) {
  const mergedClasses = twMerge(
    "px-4 py-1 rounded-full font-semibold",
    STATUS[(feature.properties.status as string) || "undefined"].style,
  );

  const release = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/managing-releases/${feature.properties.id}`);
  };

  return (
    <div className="flex flex-col gap-4 items-center px-4 py-2">
      <Heading size="sm">Soltura</Heading>

      {release.status && (
        <Text customVariant="white" size="sm" className={mergedClasses}>
          {STATUS[(release.status as string) || "undefined"].label}
        </Text>
      )}

      <div className="space-y-2">
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas:</span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>
        <Text size="sm" className="font-roboto">
          Agente: {release.executorId}
        </Text>
        <Text size="sm" className="font-roboto">
          Nome UFU: {release.ufuName}
        </Text>
        <Text size="sm" className="font-roboto">
          Espécie: {release.species}
        </Text>
        {release.executionDate && (
          <Text size="sm" className="font-roboto">
            Data/Hora: {formatDateTime(release.executionDate)}
          </Text>
        )}
      </div>
      <Button size="auto" customVariant="secondary" onClick={handleNavigate}>
        Mais Detalhes
      </Button>
    </div>
  );
}

export default ReleasePopup;
